export const formatTimeWithSuffix = (totalSeconds) => {
    if (typeof totalSeconds === 'number') {
      if (totalSeconds >= 3600) {
        
        const hours = totalSeconds / 3600;
        return `${parseFloat(hours.toFixed(2))} hr`;
      } else if (totalSeconds >= 60) {
        
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = Math.floor(totalSeconds % 60);
        return `${minutes} min ${remainingSeconds} sec`;
      } else {
       
        return `${Math.floor(totalSeconds)} sec`;
      }
    }
    return totalSeconds; 
  };